import './styles/SystemNotification.scss';

import { useQuery } from '@apollo/client';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import QUERY from 'gql/queries/MessagingService/getSystemNotifications.gql';

import InfoBox from 'app/components/InfoBox';
import { translations } from 'locales/i18n';

import GQLGuard from '../../GQLGuard';

export function SystemNotificationDialog() {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const localStorageOpenedNotifications = localStorage.getItem('systemNotifications_opened');
  const openedMessages = JSON.parse(
    localStorageOpenedNotifications ? localStorageOpenedNotifications : '[]'
  );

  const systemNotificationsQuery = useQuery<any, { full?: boolean }>(QUERY);

  const handleClose = (event, reason?, openedNotifications?) => {
    if (reason && reason === 'backdropClick') return;
    const newOpenedNotifications = [
      ...openedMessages,
      ...openedNotifications.map(notification => notification.id)
    ];
    localStorage.setItem('systemNotifications_opened', JSON.stringify(newOpenedNotifications));
    setOpen(false);
  };

  return (
    <GQLGuard query={systemNotificationsQuery} hideLoader>
      {systemNotificationsData => {
        const notOpendSystemNotifications = systemNotificationsData.systemNotifications.filter(
          notification => !openedMessages?.includes(notification.id)
        );
        if (notOpendSystemNotifications.length > 0) {
          setOpen(true);
        }
        // fix props (event,reason)
        return (
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
              {t(translations.pages.systemNotificationsSettings.systemNotifications())}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {notOpendSystemNotifications.map(notification => (
                  <div className="system-notification-dialog__item">
                    <InfoBox type={notification.type} title={notification.headline}>
                      {notification.content}
                    </InfoBox>
                  </div>
                ))}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => handleClose(null, null, notOpendSystemNotifications)}
                color="primary"
              >
                {t(translations.pages.systemNotificationsSettings.gotIt())}
              </Button>
            </DialogActions>
          </Dialog>
        );
      }}
    </GQLGuard>
  );
}
